import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalBody,
  Button,
  Text,
  Flex,
  ModalCloseButton,
  useColorModeValue
} from '@chakra-ui/react';

const ConfirmationModal = ({
  isOpen,
  onClose,
  onConfirm,
  emoji = "💡",
  title = "Confirm",
  body = "Are you sure?",
  confirmLabel = "Confirm",
  cancelLabel = "Cancel"
}) => {
  const bgColor = useColorModeValue("background.light", "background.dark");
  const darkPurple = useColorModeValue("#1b1845", "#8671cc");

  return (
    <Modal isOpen={isOpen} onClose={onClose} isCentered size="lg">
      <ModalOverlay />
      <ModalContent bg={bgColor} border="1px solid #FF60D5" borderRadius="20px">
        <ModalCloseButton />
        <ModalBody py={10} px={6}>
          <Flex align="center" justify="center" direction="column" gap={4}>
            <Text fontSize="4xl">{emoji}</Text>
            <Text fontSize="2xl" fontWeight="bold" textAlign="center">
              {title}
            </Text>
            <Text color={darkPurple} fontSize="lg" textAlign="center">
              {body}
            </Text>
            <Flex mt={4} gap={3} direction={{ base: "column", sm: "row" }} justify="center">
              <Button onClick={onClose} variant={'solid'} colorScheme={'gray'} width="160px">
                {cancelLabel}
              </Button>
              <Button onClick={onConfirm} colorScheme="brand" width="160px">
                {confirmLabel}
              </Button>
            </Flex>
          </Flex>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmationModal;
